module.exports = __webpack_public_path__ + "img/kar_no.b8cbaafe.png";